<template>
  <div class="app-details-container">
    <h2 class="app-details-heading">App Details</h2>
    <div class="app-details-row">
      <div class="app-details-form">
        <b-form-group label="App Name">
          <b-form-input
            type="text"
            v-model="appName"
            placeholder="Enter App Name"
          />
        </b-form-group>
        <b-form-group v-if="selectedPlatforms !== 'web'" label="App Version">
          <b-form-input
            type="text"
            v-model="appVersion"
            placeholder="Enter App Version"
          />
        </b-form-group>
        <b-form-group v-if="selectedPlatforms === 'web'" label="Tag Line">
          <b-form-input
            type="text"
            v-model="tagLine"
            placeholder="Enter Tag Line"
          />
          <div class="row mb-4" v-if="tagLineList && tagLineList.length">
            <b-col md="12"><p class="mb-2 font-weight-bold">AI Suggestions</p> </b-col>
            <b-col md="12">
              <ul v-if="tagLineList && tagLineList.length" class="list-unstyled">
                <li
                  class="font-weight-medium cursor-pointer mb-2"
                  v-for="(tagline, ind) in tagLineList"
                  :key="ind"
                  @click="selectTagLine(tagline)"
                >
                  <i class="fa fa-tag text-primary" font-scale="1.5" />
                  <span class="ml-2">{{ tagline }}</span>
                </li>
              </ul>
            </b-col>
          </div>
        </b-form-group>
        <b-form-group v-if="selectedPlatforms !== 'web'" label="Package Name (Optional)">
          <b-form-input
            type="text"
            v-model="packageName"
            placeholder="Enter Package Name"
          />
        </b-form-group>
      </div>
      <b-col cols="12" md="6" class="mt-3 mt-md-0">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="login-bg-label-row">
            <h4 class="login-bg-label">Login Screen Background</h4>
            <i id="button-2" class="fas fa-info-circle login-bg-tooltip"></i>
            <b-tooltip target="button-2" placement="top" triggers="hover">{{
              $t("Screen Bg Dimensions")
            }}</b-tooltip>
          </div>
        </div>
        <single-image
          height="200px"
          width="auto"
          @change="onLoginBgImgChange"
          :id="'loginBgImgid'"
          :url="loginBgImg"
          ref="loginBgImgId"
          label="Login Screen Background"
        ></single-image>
      </b-col>
    </div>
    <slot name="footer-button" :data="AppData"></slot>
  </div>
</template>

<script>
import SingleImage from "@/components/Common/Image.vue";
import { mapState } from "vuex";

export default {
  name: "AppDetails",
  data() {
    return {
      appName: "",
      appVersion: "",
      packageName: "",
      tagLine: "",
    };
  },
  props: {
    selectedPlatform: {
      type: String,
      default: null,
    },
    loginBgImg: {
      type: String,
      default: null,
    },
    marketName: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapState({
      extendedList: (state) => state.tenant.extendedList,
      tagLineList: (state) => state.auth.tagLineList,
    }),
    AppData() {
      return {
        appName: this.appName,
        appVersion: this.appVersion,
        packageName: this.packageName,
        tagLine: this.tagLine,
      };
    },
    selectedPlatforms() {
      return this.selectedPlatform;
    },
  },
  components: {
    SingleImage,
  },
  methods: {
    onLoginBgImgChange(val) {
      this.$emit("update-login-bg-img", val);
    },
    selectTagLine(tagline) {
      this.tagLine = tagline;
    },
  },
  watch: {
    selectedPlatform: {
      immediate: true,
      handler(newVal) {
        const platformConfig = this.extendedList.buildConfig[newVal];
        if (platformConfig) {
          this.appName = platformConfig.appName || "";
          this.tagLine = platformConfig.tagline || "";
        }
      },
    },
  },
};
</script>

<style scoped>
.app-details-container {
  border: 1px solid #e3eaef;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
}
.app-details-row {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  align-items: flex-start;
}
.app-details-form {
  flex: 1;
  min-width: 26px;
  width: 50%;
}
.app-details-heading {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #222;
}
.login-bg-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
}
.login-bg-label {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: #222;
}
.login-bg-tooltip {
  color: #727cf5;
  cursor: pointer;
  font-size: 18px;
  margin-left: 6px;
}
@media (max-width: 900px) {
  .app-details-row {
    flex-direction: column;
    gap: 22px;
  }
  .app-details-form {
    max-width: 100%;
  }
  .app-details-heading {
    font-size: 1.5rem;
    margin-bottom: 18px;
  }
}
@media (max-width: 580px) {
  .app-details-container {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .app-details-form {
    width: 100%;
  }
}
</style>
